import { render, staticRenderFns } from "./screen-anecdote.vue?vue&type=template&id=6bba6fc6"
import script from "./screen-anecdote.vue?vue&type=script&lang=ts"
export * from "./screen-anecdote.vue?vue&type=script&lang=ts"
import style0 from "./screen-anecdote.vue?vue&type=style&index=0&id=6bba6fc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports